module.exports = __webpack_public_path__ + "static/media/feed-transparent.8338cad4.svg";